module.exports = function() {
  return new Worker(__webpack_public_path__ + "bff6708e5d254c644268.worker.js");
};